export const calculateSum = (data, key) => {
    const validRows = data.filter(row => row[key] !== undefined && row[key] !== null);
    if (validRows.length === 0) return 0; 
    const sum = validRows.reduce((acc, row) => acc + row[key], 0);
    return sum ;
  };

 export  const calculateAverage = (data, key) => {
    const validRows = data.filter(row => row[key] !== undefined && row[key] !== null);
    if (validRows.length === 0) return 0; 
    const sum = validRows.reduce((acc, row) => acc + row[key], 0);
    const response = sum / validRows.length
    return `${response.toFixed(2)} %`;
  };

  export  const calculateAverageTwo = (data, key) => {
    const validRows = data.filter(row => row[key] !== undefined && row[key] !== null);
    if (validRows.length === 0) return 0; 
    const sum = validRows.reduce((acc, row) => acc + row[key], 0);
    const response = sum / validRows.length
    return `${response.toFixed(2)} `;
  };